export default __webpack_public_path__ + "static/privacy-v2-f9806e4945a24e68f7d4385065583f4c.pdf";